import React from "react";
import "./loader.scss";

const LoaderMin: React.FC = () => {
  return (
    <div role="status" aria-live="polite" aria-label="Cargando datos">
      <span className="loader-text c-center">Cargando datos...</span>
      <div className="loader-spinner" data-testid="divLoader" aria-hidden="true"></div>
    </div>
  );
};

export default LoaderMin;
